import { createAction, createSlice, } from "@reduxjs/toolkit";

const initialState = {
    loading: true,
    error: "",
    reports: [],
    courses: [],
    pagination: {},
};

export const activityReportSlice = createSlice({
    name: "activityReport",
    initialState,
    reducers: {
        setReports(state, action) {
            let { data, pagination } = action.payload;
            
            state.reports = data;
            state.pagination = pagination;
            state.loading = false;
        },
        setCourses: (state, action) => {
            state.courses = action.payload;
        },
        pushCourses: (state, action) => {
            state.courses = state.courses.concat(action.payload);
        },
    }
});

export const activityReportActions = {
    loadReports: createAction(`${activityReportSlice.name}/loadReports`, (payload) => ({ payload })),
    setReports: activityReportSlice.actions.setReports,
    setCourses: activityReportSlice.actions.setCourses,
    pushCourses: activityReportSlice.actions.pushCourses,
};

export const getReports = (state) => state.activityReport.reports;
export const getCourses = (state) => state.activityReport.courses;

export default activityReportSlice.reducer;